'use client'

import { Form } from '@/components/ui/form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import LiveryOrderByFilter from './livery-orderby-filter'

export const filterOptions = [
  {
    value: JSON.stringify({ updateTs: 'desc' }),
    label: 'Most Recent',
    urlLabel: 'most-recent',
  },
  {
    value: JSON.stringify({ updateTs: 'asc' }),
    label: 'Oldest',
    urlLabel: 'oldest',
  },
  {
    value: JSON.stringify({
      liveryDesignViewLog: {
        _count: 'desc',
      },
    }),
    label: 'Most Popular',
    urlLabel: 'most-popular',
  },
  {
    value: JSON.stringify({ price: 'asc' }),
    label: 'Price (low to high)',
    urlLabel: 'price-low-to-high',
  },
  {
    value: JSON.stringify({ price: 'desc' }),
    label: 'Price (high to low)',
    urlLabel: 'price-high-to-low',
  },
  {
    value: JSON.stringify({ name: 'asc' }),
    label: 'Name (A-Z)',
    urlLabel: 'name-a-z',
  },
  {
    value: JSON.stringify({ name: 'desc' }),
    label: 'Name (Z-A)',
    urlLabel: 'name-z-a',
  },
]

const FormSchema = z.object({
  orderBy: z.enum(filterOptions.map((o) => o.value)),
})

export default function LiverySearchFilters({ searchParams, applyFilters }) {
  const orderByOptionFromParam = searchParams?.orderBy
    ? filterOptions.find((o) => o.urlLabel === searchParams.orderBy)
    : null

  const form = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      orderBy: orderByOptionFromParam
        ? orderByOptionFromParam.value
        : JSON.stringify({
            liveryDesignViewLog: {
              _count: 'desc',
            },
          }),
    },
  })

  // Submit form on any value change
  useEffect(() => {
    const subscription = form.watch((value) => {
      applyFilters(value)
    })
    return () => subscription.unsubscribe()
  }, [])

  return (
    <Form {...form}>
      <form>
        <LiveryOrderByFilter options={filterOptions} />
      </form>
    </Form>
  )
}
